import React from 'react';
import { observer } from 'mobx-react';
import { ConfirmationCellTemplate } from 'themes/application/import/components';

@observer
class ConfirmationCell extends React.Component {
    render() {
        return (
            <ConfirmationCellTemplate {...this.props}/>
        );
    }
}

export default ConfirmationCell;